<template>
  <main>
    <router-view />
    <!-- Affiche le composant de la route actuelle -->
  </main>
</template>

<style>
  #app {
    font-family: "DM Sans", sans-serif;
    margin: 0;
    padding: 0;
  }
  .content-dash {
    min-height: 350px;
  }
</style>
